<app-header></app-header>
<div class="wrapper-main">
  <router-outlet></router-outlet>
  <loading-mask></loading-mask>
</div>
